<template>
    <div>
        <v-app-bar flat color="white" height="72" class="px-3" fixed app
            ><h2>System Variables</h2>
            <v-btn color="primary" class="ml-auto">Add Variable</v-btn>
        </v-app-bar>

        <v-container fluid class="pa-5">
            <v-row>
                <v-col>
                    <data-table />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import DataTable from '@/components/SystemVariables/DataTable.vue';

// export default {
//     name: 'BranchQR',
//     components: {
//         DataTable
//     },
//     data() {
//         return {};
//     },
//     created() {
//         // this.$notify({
//         //     group: 'main-notifications',
//         //     type: 'success',
//         //     title: 'Success!',
//         //     text: 'Test Notify'
//         // });
//     }
// };
export default {
    name: 'SystemVariables',
    components: {
        DataTable
    },
    data() {
        return {
            menu: false,
            confirmStatusLoading: false,
            formData: {},
            closeLoading: false
        };
    }

    // mounted() {
    //     this.initiate();
    // }
};
</script>

<style lang="scss" scoped></style>
